import { ContentType } from "../../lib/storyblok/types/blocks/RelatedContentBlock";

const TYPE_MAP = {
  events: "eventPage",
  resources: "resourcePage",
  blog: "articlePage",
};

export const processContentTypes = (contentType: ContentType): string[] => {
  if (!contentType) return [];

  let types: string[] = [];

  if (Array.isArray(contentType)) {
    types = contentType.map((type) => TYPE_MAP[type] || type);
  } else if (typeof contentType === "object" && contentType !== null) {
    types = Object.values(contentType).map((type) => TYPE_MAP[type] || type);
  } else if (typeof contentType === "string") {
    types = [TYPE_MAP[contentType] || contentType];
  }

  return types.filter(Boolean);
};

export const buildFilterQuery = (
  storyTypes: string[],
  products?: string[],
  solutions?: string[]
): string => {
  // Check if all filter arrays are empty
  const allFiltersEmpty =
    !storyTypes.length &&
    (!products || !products.length) &&
    (!solutions || !solutions.length);

  if (allFiltersEmpty) {
    return "id:no-results-match-this-id";
  }

  const filters: string[] = [];

  if (storyTypes.length > 0) {
    const storyTypeFilter = storyTypes
      .map((type) => `storyType:${type}`)
      .join(" OR ");
    filters.push(`(${storyTypeFilter})`);
  }

  if (products && products.length > 0) {
    const productsFilter = products
      .map((product) => `categories:"${product}"`)
      .join(" OR ");
    filters.push(`(${productsFilter})`);
  }

  if (solutions && solutions.length > 0) {
    const solutionsFilter = solutions
      .map((solution) => `solutions:"${solution}"`)
      .join(" OR ");
    filters.push(`(${solutionsFilter})`);
  }

  return filters.join(" AND ");
};
